module.exports = __webpack_public_path__ + "static/img/ch.7725a9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ch.png
// module id = 4T8p
// module chunks = 3